// extracted by mini-css-extract-plugin
export var divider = "_is-0";
export var systemMessage = "_is-1";